
$(document).on("pagecontainershow", function(event, ui) {
    // add custom remove and update functions to cart when init
    if (ui.toPage[0].id == 'cart') {
    removeitem();
    updatequantity();
    }
    // if coming from cart page remove it
    if (ui.prevPage === undefined) {
    if (ui.prevPage[0].id == 'cart') {
        jQuery(ui.prevPage[0]).remove();
        //scroll back to previous position
        $.mobile.silentScroll(window.cartscrolltop);
    }
    }
});




$(document).on("pagecontainerhide", function(event, ui) {
    // always remove cart from dom
    if (ui.prevPage[0].id == 'cart') {
      $(ui.prevPage[0]).remove();
    }
});





function updatequantity() {
    $('.btn-number').unbind().click(function(e) {
        e.preventDefault();




        fieldName = $(this).attr('data-field');
        type = $(this).attr('data-type');
        var input = $(this).closest('.quantity-wrap').find("input[type='number']");
        var currentVal = parseInt(input.val());
        if (!isNaN(currentVal)) {
            if (type == 'minus') {

                if (currentVal > input.attr('min')) {
                    input.val(currentVal - 1).change();
                }
                if (parseInt(input.val()) == input.attr('min')) {
                    $(this).attr('disabled', true);
                }

            } else if (type == 'plus') {
                if (currentVal < input.attr('max')) {
                    input.val(currentVal + 1).change();
                }
                if (parseInt(input.val()) == input.attr('max')) {
                    $(this).attr('disabled', true);
                }

            }
        } else {
            input.val(0);
        }
    });
    $('.input-number').focusin(function() {
        $(this).data('oldValue', $(this).val());
    });
    $('.input-number').change(function() {

        minValue = parseInt($(this).attr('min'));
        maxValue = parseInt($(this).attr('max'));
        valueCurrent = parseInt($(this).val());

        name = $(this).attr('id');
        if (valueCurrent >= minValue) {
            $(".btn-number[data-type='minus'][data-field='" + name + "']").removeAttr('disabled')
        } else {
            alert('Sorry, the minimum value was reached');
            $(this).val($(this).data('oldValue'));
        }
        if (valueCurrent <= maxValue) {
            $(".btn-number[data-type='plus'][data-field='" + name + "']").removeAttr('disabled')
        } else {
            alert('Sorry, the maximum value was reached');
            $(this).val($(this).data('oldValue'));
        }


    });
    $(".input-number").keydown(function(e) {
        // Allow: backspace, delete, tab, escape, enter and .
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode == 65 && e.ctrlKey === true) ||
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    });




    $("#cartform input.quantity").change(function() {

        // get current scroll position 
        window.cartscrolltop = $(window).scrollTop();

        var item_id = $(this).attr('id').replace('updates_', '');
        var item_quantity = $(this).val();
        var updatestring = 'updates[' + item_id + ']=' + item_quantity;
        jQuery.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: updatestring,
            async: false,
            cache: false,
            dataType: 'json',
            success: function(data) {
                cartcall(data);
            },
            error: Shopify.onError
        });

      if(jQuery(this).val() == 0) {
        // reload cart page
        jQuery(this).closest('.product-cart-wrap').fadeOut(400, function() {
           $( ":mobile-pagecontainer" ).pagecontainer( "change", "/cart", {  showLoadMsg: true, reload: true, transition: "none", changeHash: "false" });
        });
      }else{
         $( ":mobile-pagecontainer" ).pagecontainer( "change", "/cart", {  showLoadMsg: true, reload: true, transition: "none", changeHash: "false" });
      }
        // add function for updating cart icons
    });

}



function removeitem() {
    $("#cartform .remove").unbind().click(function(e) {
        e.preventDefault();
        var productid = jQuery(this).attr('product-id');


        jQuery.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: 'updates[' + productid + ']=0',
            async: false,
            cache: false,
            dataType: 'json',
            success: function(data) {
                cartcall(data);
            },
            error: Shopify.onError
        });
        // reload cart page
        jQuery(this).closest('.product-cart-wrap').fadeOut(400, function() {
           $( ":mobile-pagecontainer" ).pagecontainer( "change", "/cart", {  showLoadMsg: true,
                reload: true,
                transition: "none" });
        });

    });
}



function cartcall(data) {
    // refresh cart icons
    jQuery('.cart-count').html(data.item_count);
    // check for hasitem on zero
    if (data.item_count < 1) {
        $('.cart-target').removeClass('hasitem');
    } else {
        $('.cart-target').addClass('hasitem');
    }
}